<template>
    <div :class="'contentcols-'+length" class="wrapper">
         <div class="columns m-b-0-tablet is-hidden-tablet">
            <div class="column">
                <p><span @click="$store.commit('search/SET_BACKBTN_RESULTS', true),$router.back()" class="btn btn-clear">Back</span></p>
            </div>
        </div>
        <div class="columns is-desktop filters-wrapper">
            <div class="column is-9-desktop filters my-0 py-0">
                <div class="filters-grow">
                    <span @click="$store.commit('compare/SET_TYPE_BACK_BTN', true), $router.go(-1)" class="btn btn-clear">Back</span>
                </div>
                <div class="see-returns filters-grow">
                    <currency-toggle :isDisabled="true" />
                </div>
                <div class="mt-3 is-hidden-tablet">
                    <a href="#"><img style="width: 100%;height: auto" src="/img/banner-Compare-mb.png" /></a>
                </div>
            </div>
        </div>
        <div class="columns is-desktop header-detailed-view">
            <div class="column is-12-desktop">
                <div class="columns is-desktop">
                    <div class="column is-7-desktop p-r-50-desktop">
                        <div class="header-search header-detailed">
                            <div>
                                <h1 class="is-size-5 is-size-4-desktop has-text-weight-bold m-b-0"> Detailed view</h1>

                            </div>
                            <div class="is-hidden-mobile header-detailed-help"><page-help :height="'510px'" :pageHelp="'detailed'"/></div>
                            <div class="see-returns view-toggle is-mobile">
                                <currency-toggle :isDisabled="true" />
                            </div>
                            <div></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--
        <div class="columns p-l-100 is-mobile">
            <div class="column is-12-desktop pl-6">
                <ul class="short-links my-0">
                    <li>
                        <b-dropdown aria-role="list">
                            <button class="button is-primary" slot="trigger" slot-scope="{ active }">
                                <

                                span>Go to</span>
                                <b-icon :icon="active ? 'menu-up' : 'menu-down'"></b-icon>
                            </button>
                            <b-dropdown-item aria-role="listitem" v-scroll-to="{ el: '#a1', offset: -230 }">
                                General
                            </b-dropdown-item>
                            <b-dropdown-item aria-role="listitem"v-scroll-to="{ el: '#a2', offset: -230 }">
                                Performance
                            </b-dropdown-item>
                            <b-dropdown-item aria-role="listitem" v-scroll-to="{ el: '#a3', offset: -230 }">
                                Fees
                            </b-dropdown-item>
                            <b-dropdown-item aria-role="listitem" v-scroll-to="{ el: '#a4', offset: -230 }">
                                Distributions
                            </b-dropdown-item>
                            <b-dropdown-item aria-role="listitem" v-scroll-to="{ el: '#a5', offset: -230 }">
                                Price
                            </b-dropdown-item>
                            <b-dropdown-item aria-role="listitem" v-scroll-to="{ el: '#a6', offset: -230 }">
                                Ratings
                            </b-dropdown-item>
                            <b-dropdown-item aria-role="listitem" v-scroll-to="{ el: '#a7', offset: -230 }">
                                Portfolio
                            </b-dropdown-item>
                        </b-dropdown>
                    </li>
                </ul>
            </div>
        </div>-->


        <div class="columns is-desktop">
            <div class="column is-12-mobile is-9-desktop">
                <div  class="grid-cols m-b-20">
                    <div class="col principal-col">
                        <div class="go-to-button-wrap cell cell-header header-tablet">
                            <ul class="short-links my-0">
                                <li>
                                    <b-dropdown aria-role="list">
                                        <button class="button is-primary go-to-button" slot="trigger" slot-scope="{ active }">
                                            <span class="is-size-5-tablet is-size-6-mobile">Go to</span>
                                            <b-icon :icon="active ? 'menu-up' : 'menu-down'"></b-icon>
                                        </button>
                                        <b-dropdown-item aria-role="listitem" v-scroll-to="{ el: '#a1', offset: -280 }">
                                            General
                                        </b-dropdown-item>
                                        <b-dropdown-item aria-role="listitem" v-scroll-to="{ el: '#a2', offset: -280 }">
                                            Performance
                                        </b-dropdown-item>
                                        <b-dropdown-item aria-role="listitem" v-scroll-to="{ el: '#a3', offset: -280 }">
                                            Fees
                                        </b-dropdown-item>
                                        <b-dropdown-item aria-role="listitem" v-scroll-to="{ el: '#a4', offset: -280 }">
                                            Distributions
                                        </b-dropdown-item>
                                        <b-dropdown-item aria-role="listitem" v-scroll-to="{ el: '#a5', offset: -280 }">
                                            Price
                                        </b-dropdown-item>
                                        <b-dropdown-item aria-role="listitem" v-scroll-to="{ el: '#a6', offset: -280 }">
                                            Ratings
                                        </b-dropdown-item>
                                        <b-dropdown-item aria-role="listitem" v-scroll-to="{ el: '#a7', offset: -280 }">
                                            Portfolio
                                        </b-dropdown-item>
                                    </b-dropdown>
                                </li>
                            </ul>
                        </div>
                        <div class="cell is-hidden-tablet cell-buttons-actions">
                        </div>
                        <div id="a1" class="cell cell-title">
                            <h3 class="title-cell">General</h3>
                        </div>
                        <div class="cell legal-structure">
                            <p>Full Legal Name</p>
                        </div>
                        <div class="cell">
                            <p>Category</p>
                        </div>
                        <div class="cell">
                            <p>Legal Structure<button v-tooltip="{content: 'Fund\'s Legal Structure', trigger: 'hover click'}">?</button></p>
                        </div>
                        <div class="cell">
                            <p>Style<button v-tooltip="{content: 'Management Style', trigger: 'hover click'}">?</button></p>
                        </div>
                        <div class="cell investment">
                            <p class="investment-title">Investment strategy</p>
                        </div>

                        <div class="cell">
                            <p><a class="has-text-weight-bold has-text-underline" href="/pages/fund-investing-glossary?anchor=benchmark" target="_blank">Benchmark</a><button v-tooltip="{content: 'Fund\'s chosen Benchmark', trigger: 'hover click'}">?</button></p>
                        </div>

                        <div class="cell">
                            <p><a class="has-text-weight-bold has-text-underline" href="/pages/fund-investing-glossary?anchor=isa" target="_blank">ISA Eligible</a><button v-tooltip="{content: 'Availability within the Fund', trigger: 'hover click'}">?</button></p>
                        </div>

                        <div class="cell">
                            <p><a class="has-text-weight-bold has-text-underline" href="/pages/fund-investing-glossary?anchor=sipp" target="_blank">SIPP Eligible</a><button v-tooltip="{content: 'Availability within the Fund', trigger: 'hover click'}">?</button></p>
                        </div>

                        <div class="cell">
                            <p><a class="has-text-weight-bold has-text-underline" href="/pages/fund-investing-glossary?anchor=ESG(Environmental,Social,andGovernance)" target="_blank">ESG</a><button v-tooltip="{content: 'Availability within the Fund', trigger: 'hover click'}">?</button></p>
                        </div>

                        <div class="cell">
                            <p>Domicile</p>
                        </div>

                        <div class="cell">
                            <p>Creation Date<button v-tooltip="{content: 'Share Class launch date', trigger: 'hover click'}">?</button></p>
                        </div>


                        <div class="cell">
                            <p>Years Since Launch</p>
                        </div>


                        <div class="cell">
                            <p><a class="has-text-weight-bold has-text-underline" href="/pages/fund-investing-glossary?anchor=physicallyreplicatedetf" target="_blank">Physically Replicated</a></p>
                        </div>

                        <div class="cell">
                            <p>Asset Manager</p>
                        </div>


                        <div class="cell investment">
                            <p class="investment-title">Portfolio Manager <br>& Start Date</p>
                        </div>

                        <!--                        <div class="cell">
                                                    <p>Manager Start Date</p>
                                                </div>

                                                <div class="cell">
                                                    <p>Manager Tenure</p>
                                                </div>-->


                        <div class="cell">
                            <p>Manager Tenure</p>
                        </div>

                        <div class="cell">
                            <p>Focus Region<button v-tooltip="{content: 'Only for Investment Trusts', trigger: 'hover click'}">?</button></p>
                        </div>
                        <div class="cell">
                            <p><a class="has-text-weight-bold has-text-underline" href="/pages/fund-investing-glossary?anchor=aic:" target="_blank">AIC Sector</a><button v-tooltip="{content: 'Association of Investment Companies (AIC) classification / only for Investment Trusts', trigger: 'hover click'}">?</button></p>
                        </div>
                        <div class="cell">
                            <p><a class="has-text-weight-bold has-text-underline" href="/pages/fund-investing-glossary?anchor=ia" target="_blank">IA Sector</a><button v-tooltip="{content: 'Sector defined by the Investment Association (IA)', trigger: 'hover click'}">?</button></p>
                        </div>
                        <div class="cell">
                            <p><a class="has-text-weight-bold has-text-underline" href="/pages/fund-investing-glossary?anchor=ticker" target="_blank">Ticker</a><button v-tooltip="{content: 'LSE Code for Investment Trusts or ETFs also referred to as EPIC', trigger: 'hover click'}">?</button></p>
                        </div>
                        <div class="cell cell-title">
                            <h3 id="a2"  class="title-cell">Performance</h3>
                        </div>


                        <div class="cell cell-text-long">
                            <p><a class="has-text-weight-bold has-text-underline" href="/pages/fund-investing-glossary?anchor=shareclass" target="_blank">Share Class</a><button v-tooltip="{content: 'Share Class used to represent the Fund', trigger: 'hover click'}">?</button></p>
                        </div>

                        <div class="cell">
                            <p><a class="has-text-weight-bold has-text-underline" href="/pages/fund-investing-glossary?anchor=isin(internationalsecuritiesidentificationnumber)" target="_blank">ISIN</a><button v-tooltip="{content: 'Unique identifier. Usually found at the top of all investor documents', trigger: 'hover click'}">?</button></p>
                        </div>

                        <div class="cell">
                            <p><a class="has-text-weight-bold has-text-underline" href="/pages/fund-investing-glossary?anchor=annualisednettotalreturn" target="_blank">NTR YTD</a></p>
                        </div>

                        <div class="cell">
                            <p><a class="has-text-weight-bold has-text-underline" href="/pages/fund-investing-glossary?anchor=annualisednettotalreturn" target="_blank">NTR 1Y</a><button v-tooltip="{content: 'Annualised Net Total Return 1 Year', trigger: 'hover click'}">?</button></p>
                        </div>

                        <div class="cell">
                            <p><a class="has-text-weight-bold has-text-underline" href="/pages/fund-investing-glossary?anchor=annualisednettotalreturn" target="_blank">NTR 3Y</a><button v-tooltip="{content: 'Annualised Net Total Return 3 Year', trigger: 'hover click'}">?</button></p>
                        </div>

                        <div class="cell">
                            <p><a class="has-text-weight-bold has-text-underline" href="/pages/fund-investing-glossary?anchor=annualisednettotalreturn" target="_blank">NTR 5Y</a><button v-tooltip="{content: 'Annualised Net Total Return 5 Year', trigger: 'hover click'}">?</button></p>
                        </div>

                        <div class="cell">
                            <p><a class="has-text-weight-bold has-text-underline" href="/pages/fund-investing-glossary?anchor=standarddeviation" target="_blank">3Y SD</a><button v-tooltip="{content: '3 Year Standard Deviation', trigger: 'hover click'}">?</button></p>
                        </div>

                        <div class="cell">
                            <p><a class="has-text-weight-bold has-text-underline" href="/pages/fund-investing-glossary?anchor=maximumdrawdown" target="_blank">3Y Max Drawdown</a></p>
                        </div>

                        <div class="cell">
                            <p><a class="has-text-weight-bold has-text-underline" href="/pages/fund-investing-glossary?anchor=sharperatio" target="_blank">3Y Sharpe Ratio</a></p>
                        </div>

                        <div class="cell">
                            <p>
                                Spread vs User Benchmark YTD
                                <button v-tooltip="{content: 'Select benchmark from yellow drop-down on results page', trigger: 'hover click'}">?</button>
                            </p>
                        </div>

                        <div class="cell">
                            <p>
                                Spread vs User Benchmark 1Y
                                <button v-tooltip="{content: 'Select benchmark from yellow drop-down on results page', trigger: 'hover click'}">?</button>
                            </p>
                        </div>

                        <div class="cell">
                            <p>
                                Spread vs User Benchmark 3Y
                                <button v-tooltip="{content: 'Select benchmark from yellow drop-down on results page', trigger: 'hover click'}">?</button>
                            </p>
                        </div>

                        <div class="cell">
                            <p>
                                Spread vs User Benchmark 5Y
                                <button v-tooltip="{content: 'Select benchmark from yellow drop-down on results page', trigger: 'hover click'}">?</button>
                            </p>
                        </div>


                        <div class="cell cell-title">
                            <h3 id="a3"  class="title-cell">Fees</h3>
                        </div>

                        <div class="cell">
                            <p><a class="has-text-weight-bold has-text-underline" href="/pages/fund-investing-glossary?anchor=ongoingcharge" target="_blank">OGC (includes Mgt Fee)</a><button v-tooltip="{content: 'Ongoing Charge (includes Mgt Fee)', trigger: 'hover click'}">?</button></p>
                        </div>

                        <div class="cell">
                            <p><a class="has-text-weight-bold has-text-underline" href="/pages/fund-investing-glossary?anchor=managementfee" target="_blank">Mgt Fee</a><button v-tooltip="{content: 'Management Fee', trigger: 'hover click'}">?</button></p>
                        </div>

                        <div class="cell">
                            <p><a class="has-text-weight-bold has-text-underline" href="/pages/fund-investing-glossary?anchor=performancefee" target="_blank">Performance Fee</a></p>
                        </div>



                        <div class="cell cell-title">
                            <h3 id="a4"  class="title-cell">Distributions</h3>
                        </div>


                        <div class="cell">
                            <p><a class="has-text-weight-bold has-text-underline" href="/pages/fund-investing-glossary?anchor=yield" target="_blank">Yield</a><button v-tooltip="{content: '12m Yield', trigger: 'hover click'}">?</button></p>
                        </div>

                        <div class="cell">
                            <p><a class="has-text-weight-bold has-text-underline" href="/pages/fund-investing-glossary?anchor=accumulationunit" target="_blank">Units Available</a><button v-tooltip="{content: 'What\'s available in one or more of the Fund\'s Share Classes', trigger: 'hover click'}">?</button></p>
                        </div>

                        <div class="cell">
                            <p>Frequency<button v-tooltip="{content: 'What\'s available in one or more of the Fund\'s Share Classes', trigger: 'hover click'}">?</button></p>
                        </div>

                        <div class="cell cell-title">
                            <h3 id="a5"  class="title-cell">Price</h3>
                        </div>


                        <div class="cell">
                            <p>Currency</p>
                        </div>

                        <div class="cell">
                            <p>Other Currencies Available<button v-tooltip="{content: 'Availability in the Fund\'s other Share Classes', trigger: 'hover click'}">?</button></p>
                        </div>

                        <div class="cell">
                            <p><a class="has-text-weight-bold has-text-underline" href="/pages/fund-investing-glossary?anchor=currencyhedged" target="_blank">Currency Hedged Available</a><button v-tooltip="{content: 'What\'s available in one or more of the Fund\'s Share Classes', trigger: 'hover click'}">?</button></p>
                        </div>

                        <div class="cell">
                            <p><a class="has-text-weight-bold has-text-underline" href="/pages/fund-investing-glossary?anchor=netassetvaluepershare(navpershare)" target="_blank">Last NAV </a><button v-tooltip="{content: 'Last Net Asset Value', trigger: 'hover click'}">?</button></p>
                        </div>

                        <div class="cell">
                            <p>Last NAV Date <button v-tooltip="{content: 'Last Net Asset Value Date', trigger: 'hover click'}"
                            >?</button></p>
                        </div>

                        <!-- <div class="cell">
                            <p>Close Price</p>
                        </div>


                        <div class="cell">
                            <p>Close Price Date</p>
                        </div> -->



                        <div class="cell">
                            <p class="is-hidden-mobile"><a class="has-text-weight-bold has-text-underline" href="/pages/fund-investing-glossary?anchor=netassetvalue(nav)discountpremium" target="_blank">Discount/Premium to NAV</a></p>
                            <p class="is-hidden-tablet"><a class="has-text-weight-bold has-text-underline" href="/pages/fund-investing-glossary?anchor=netassetvalue(nav)discountpremium" target="_blank">Discount/ Premium to NAV</a></p>
                        </div>

                        <div class="cell">
                            <p>Day on Day Change <button v-tooltip="{content: 'Daily Close Price Change for ITs & ETFs, Daily NAV Change for the rest', trigger: 'hover click'}"
                            >?</button></p>
                        </div>


                        <div class="cell cell-title">
                            <h3 id="a6"  class="title-cell">Ratings</h3>
                        </div>


                        <div class="cell">
                            <p>Risk Rating<button v-tooltip="{content: 'Morningstar Risk Rating. From 1-5... 1=lower risk, 5=higher risk', trigger: 'hover click'}">?</button></p>
                        </div>

                        <div class="cell">
                            <p>Star Rating<button v-tooltip="{content: 'Morningstar Rating', trigger: 'hover click'}">?</button></p>
                        </div>


                        <div class="cell cell-title">
                            <h3 id="a7"  class="title-cell">Portfolio</h3>
                        </div>



                        <div class="cell">
                            <p><a class="has-text-weight-bold has-text-underline" href="/pages/fund-investing-glossary?anchor=fundnetassets" target="_blank">Net Assets</a><button v-tooltip="{content: 'Fund Net assets', trigger: 'hover click'}">?</button></p>
                        </div>

                        <div class="cell">
                            <p>Number of Holdings</p>
                        </div>

                    </div>
                    <div v-if="a" class="col" :class="highlightLeft ? 'z-index-52' : ''">
                        <div class="cell cell-header header-tablet">
                            <h3 class="has-text-centered text-overflow pr-3">{{getShort(a.FundBasicsName)}}</h3>
                            <div class="buttons-actions is-hidden-mobile" @click="highlightModal('left')">
                               <buttons :ISIN="a.ISIN" :fund-id="a.fund_id" :fund_data="a"></buttons>
                            </div>
                        </div>
                        <div class="cell cell-buttons-actions is-hidden-tablet">
                            <buttons :ISIN="a.ISIN" :fund-id="a.fund_id" :fund_data="a"></buttons>
                        </div>
                        <div class="cell">
                            <!-- <a @click="soonModalActive1=true" class="download has-text-centered">Factsheet <img src="/img/download.svg"></a> -->
                        </div>
                        <div class="cell legal-structure">
                            <p v-if="a.LegalStructureLegalName" class="has-text-centered">{{a.LegalStructureLegalName}}</p>
                            <span v-else style="color: #999">n/a</span>
                        </div>
                        <div class="cell">
                            <p v-if="a.morningstarcategories" class="has-text-centered">{{a.morningstarcategories}}</p>
                            <span v-else style="color: #999">n/a</span>
                        </div>

                        <div class="cell cell-centered">
                            <p class="has-text-centered">{{ a.LegalStructure }}</p>
                        </div>

                        <div class="cell cell-centered">
                            <p class="has-text-centered">

                                <span v-if="a.IndexFund" class="label" style="background-color: #AFEF97; color: #363636;">Passive</span>
                                <span class="label active" v-else
                                >Active</span>

                            </p>
                        </div>

                        <div class="cell investment">
                            <div class="investment-text">
                                <p class="has-text-centered">{{a.InvestmentStrategy}}</p>
                            </div>
                        </div>

                        <div class="cell cell-centered">
                            <p class="has-text-centered">{{bmark(a.benchmark)}}</p>
                        </div>

                        <div class="cell cell-centered">
                            <p class="has-text-centered">
                                <span v-if="a.isa_all || a.isa_platforms"><img class="no-yes" src="/img/tick.svg"></span>
                                <span v-else><img class="no-yes" src="/img/cross.svg"></span>
                            </p>
                        </div>

                        <div class="cell cell-centered">
                            <p class="has-text-centered">
                                <span v-if="a.sipp_all || a.sipp_platforms"><img class="no-yes" src="/img/tick.svg"></span>
                                <span v-else><img class="no-yes" src="/img/cross.svg"></span>
                            </p>
                        </div>

                        <div class="cell cell-centered">
                            <p class="has-text-centered">
                                <span v-if="a.is_esg">{<img class="no-yes" src="/img/tick.svg"></span>
                                <span v-else><img class="no-yes" src="/img/cross.svg"></span>
                            </p>
                        </div>

                        <div class="cell cell-centered">
                            <p class="has-text-centered">{{a.Domicile}}</p>
                        </div>

                        <div class="cell cell-centered">
                            <p class="has-text-centered" v-html="format_date(a.InceptionDate)"></p>
                        </div>

                        <div class="cell cell-centered">
                            <p class="has-text-centered">
                                {{formatDateToYear(a.InceptionDate)}}
                            </p>
                        </div>


                        <div class="cell cell-centered">
                            <p class="has-text-centered">
                                <span v-if="a.IndexFund === false">N/A</span>
                                <span v-else-if="a.PhysicalFull || a.PhysicalSample">Yes</span>
                                <span v-else>No</span>
                            </p>
                        </div>

                        <div class="cell cell-centered">
                            <p class="has-text-centered">{{ a.CompanyBasicsName }}</p>
                        </div>

                        <div class="cell investment cell-centered">
                            <div class="investment-text" v-if="JSON.parse(a.fundmanagers).length > 0">
                                <p v-for="m in JSON.parse(a.fundmanagers)" :key="m.manager_id">
                                    {{m.GivenName}} {{m.FamilyName}} <br>{{format_date(m.StartDate)}}
                                </p>
                            </div>
                            <div class="has-text-centered" v-else>
                                <span style="color: #999">n/a</span>
                            </div>
                        </div>

                        <!--                        <div class="cell cell-centered">
                                                    <p class="has-text-centered">
                                                    <span v-for="m in JSON.parse(a.fundmanagers)" :key="m.manager_id">
                                                        <div>{{format_date(m.StartDate)}}</div>
                                                    </span>
                                                    </p>
                                                </div>
                                                <div class="cell cell-centered">
                                                    <p class="has-text-centered">
                                                    <span v-for="m in this.managers" :key="m.manager_id">
                                                        <span>{{timeSince(m.StartDate)}}</span>
                                                    </span>
                                                    </p>
                                                </div>-->


                        <div class="cell cell-centered">
                            <p v-if="a.oldest_manager_date_ago" class="has-text-centered">
                                {{a.oldest_manager_date_ago}} {{a.oldest_manager_date_ago > 1 ? 'years' : 'year'}}
                            </p>
                            <span v-else style="color: #999">n/a</span>
                        </div>

                        <div class="cell cell-centered">
                            <p v-if="a.CountryFocusId" class="has-text-centered">
                                {{a.CountryFocusId}}
                            </p>
                            <span v-else style="color: #999">n/a</span>
                        </div>
                        <div class="cell cell-centered">
                            <p v-if="a.SectorFocusId" class="has-text-centered">
                                {{a.SectorFocusId}}
                            </p>
                            <span v-else style="color: #999">n/a</span>
                        </div>
                        <div class="cell cell-centered">
                            <p v-if="a.ima_name" class="has-text-centered">
                                {{a.ima_name}}
                            </p>
                            <span v-else style="color: #999">n/a</span>
                        </div>
                        <div class="cell cell-centered">
                            <p v-if="a.ticker" class="has-text-centered">
                                {{a.ticker}}
                            </p>
                            <span v-else style="color: #999">n/a</span>
                        </div>

                        <div class="cell cell-empty">

                        </div>

                        <div class="cell cell-centered cell-text-long">
                            <p class="has-text-centered">
                                {{a.ShareClassBasicsName}}
                            </p>
                        </div>

                        <div class="cell cell-centered">
                            <p class="has-text-centered">

                                {{a.ISIN}}

                            </p>
                        </div>


                        <div class="cell cell-centered is-size-7-mobile">
                            <pos-neg :val="a.CumulativeTotalReturnTD" :round="2" :suffix="'%'"/>
                        </div>

                        <div class="cell cell-centered is-size-7-mobile">
                            <pos-neg :val="a.CumulativeTotalReturn1Year" :round="2" :suffix="'%'"/>
                        </div>



                        <div class="cell cell-centered is-size-7-mobile">
                            <pos-neg :val="a.TotalReturn3Years" :round="2" :suffix="'%'"/>
                        </div>


                        <div class="cell cell-centered is-size-7-mobile">
                            <pos-neg :val="a.TotalReturn5Years" :round="2" :suffix="'%'"/>
                        </div>

                        <div class="cell cell-centered is-size-7-mobile">
                            <pos-neg :val="a.standarddev36m" :round="2" :suffix="'%'"/>
                        </div>

                        <div class="cell cell-centered is-size-7-mobile">
                            <pos-neg :val="a.maxdrawdown3Y" :round="2" :suffix="'%'"/>
                        </div>

                        <div class="cell cell-centered is-size-7-mobile">
                            <pos-neg :val="a.sharperatio3Y" :round="2" :suffix="''"/>
                        </div>

                        <div class="cell cell-centered is-size-7-mobile">
                            <pos-neg v-if="isSpreadBenchmarkSelected" :val="a.CumulativeTotalReturnTD - (isSpreadBenchmarkSelected.benchmarkTD ? isSpreadBenchmarkSelected.benchmarkTD : a.spreadvsbenchmarkytd)" :round="2" :suffix="'%'" :bg-color="benchmarkHighlightColor"/>
                            <div v-else class="has-text-weight-bold">Select Benchmark</div>
                        </div>

                        <div class="cell cell-centered is-size-7-mobile">
                            <pos-neg v-if="isSpreadBenchmarkSelected" :val="a.CumulativeTotalReturn1Year - (isSpreadBenchmarkSelected.benchmark1Y ? isSpreadBenchmarkSelected.benchmark1Y : a.spreadvsbenchmark1y)" :round="2" :suffix="'%'" :bg-color="benchmarkHighlightColor"/>
                            <div v-else class="has-text-weight-bold">Select Benchmark</div>
                        </div>

                        <div class="cell cell-centered is-size-7-mobile">
                            <pos-neg v-if="isSpreadBenchmarkSelected" :val="a.TotalReturn3Years - (isSpreadBenchmarkSelected.benchmark3Y ? isSpreadBenchmarkSelected.benchmark3Y : a.spreadvsbenchmark3y)" :round="2" :suffix="'%'" :bg-color="benchmarkHighlightColor"/>
                            <div v-else class="has-text-weight-bold">Select Benchmark</div>
                        </div>

                        <div class="cell cell-centered is-size-7-mobile">
                            <pos-neg v-if="isSpreadBenchmarkSelected" :val="a.TotalReturn5Years - (isSpreadBenchmarkSelected.benchmark5Y ? isSpreadBenchmarkSelected.benchmark5Y : a.spreadvsbenchmark5y)" :round="2" :suffix="'%'" :bg-color="benchmarkHighlightColor"/>
                            <div v-else class="has-text-weight-bold">Select Benchmark</div>
                        </div>

                        <div class="cell cell-empty">

                        </div>

                        <div class="cell cell-centered is-size-7-mobile">
                            <pos-neg :val="a.ongoingchargecomp" :round="2" :suffix="'%'"/>
                        </div>

                        <div class="cell cell-centered is-size-7-mobile">
                            <pos-neg :val="a.ManagementFeeValue" :round="2" :suffix="'%'"/>
                        </div>

                        <div class="cell cell-centered is-size-7-mobile">
                            <p v-bind:class = "(a.PerformanceFeeValue < 0)?'red has-text-centered':'has-text-centered'">
                                <span v-if="a.PerformanceFeeValue">{{a.performancefee_oldest_share}}%</span>
                                <span v-else>N/A</span>
                            </p>
                        </div>


                        <div class="cell cell-empty">

                        </div>

                        <div class="cell cell-centered is-size-7-mobile">

                            <pos-neg :val="a.yield12m" :round="2" :suffix="'%'"/>

                        </div>

                        <div class="cell cell-centered">
                            <p class="has-text-centered" v-html="accinc(a, $store.state.search.lastSearch)">

<!--                                <span v-if="a.IncomeDistribution && a.AccumulatedDistribution">INCOME & ACCUMULATION</span>
                                <span v-else-if="a.IncomeDistribution">INCOME</span>
                                <span v-else-if="a.AccumulatedDistribution">ACCUMULATION</span>
                                <span v-else>-</span>-->


                            </p>
                        </div>

                        <div class="cell cell-centered">
                            <p v-if="JSON.parse(a.distributionfrequency_all).length > 0" class="has-text-centered">
                            <span v-for="(f, index) in JSON.parse(a.distributionfrequency_all)" :key="index">
                                {{getFreq(f)}}
                            </span>
                            </p>
                            <p v-else style="color: #999">n/a</p>
                        </div>


                        <div class="cell cell-empty">

                        </div>

                        <div class="cell cell-centered">
                            <p class="has-text-centered">

                               {{a.CurrencyId}}
                            </p>
                        </div>


                        <div class="cell cell-centered">
                            <p class="has-text-centered">

                                <span v-if="a.othercurrencies_all === true">Yes</span>
                                <span v-else>No</span>

                            </p>
                        </div>


                        <div class="cell cell-centered">
                            <p class="has-text-centered">

                                <span v-if="a.currencyhedged_all">Yes</span>
                                <span v-else>No</span>

                            </p>
                        </div>

                        <div class="cell cell-centered">
                            <pos-neg :val="a.NAV" :round="2" />

                        </div>

                        <div class="cell cell-centered">
                            <p class="has-text-centered" v-html="format_date(a.Lastupdated)">

                            </p>
                        </div>

                        <!-- <div class="cell cell-centered">
                            <pos-neg :val="a.ClosePrice" :round="2" />
                        </div>

                        <div class="cell cell-centered">
                            <p class="has-text-centered" v-html="format_date(a.Navdate)"></p>
                        </div> -->

                        <div class="cell cell-centered">

                            <pos-neg :val="a.discounttoNAV" :round="2" :suffix="'%'"/>

                        </div>

                        <div class="cell cell-centered">
                            <pos-neg :val="a.ChangeInPrice" :round="2" :suffix="'%'"/>
                        </div>

                        <div class="cell cell-centered">
                            <p class="has-text-centered">

                            </p>
                        </div>

                        <div v-bind:class = "(a.riskrating_6M < 0)?'red cell cell-empty has-text-centered':'cell cell-empty has-text-centered'">
                             <pos-neg :val="a.riskrating_6M" :round="0"  />
                        </div>

                        <div class="cell cell-centered">
                            <p class="has-text-centered">

                            <span class="is-white-space-nowrap" v-if="a.starrating36M && !isNaN(a.starrating36M)">

                                <span v-for="(r, index) in parseInt(a.starrating36M)" :key="index"><img class="star" src="/img/star-2.svg"/></span>

                            </span>
                                <span v-else style="color: #999">n/a</span>

                            </p>
                        </div>

                        <div class="cell cell-empty">

                        </div>

                        <div class="cell cell-centered">
                            <p v-bind:class = "(a.fundnetassetgbp < 0)?'red has-text-centered':'has-text-centered'" >

                                <span>{{currency("GBP", parseNA(a.fundnetassetgbp)) }}m</span>
                            </p>
                        </div>


                        <div class="cell cell-centered">
                            <p v-bind:class = "(a.NumberOfHolding < 0)?'red has-text-centered':'has-text-centered'" >
                                <pos-neg :val="a.NumberOfHolding" :round="0"/>
                            </p>
                        </div>

                    </div>
                    <div v-if="i" class="col current-col" :class="highlightCenter ? 'z-index-52' : ''">

                        <div class="cell cell-header header-tablet">
                            <h3 class="has-text-centered text-overflow">{{getShort(i.FundBasicsName)}}</h3>
                            <div class="buttons-actions is-hidden-mobile" @click="highlightModal('center')">
                                <buttons :ISIN="i.ISIN"  :fund-id="i.fund_id" :fund_data="i"></buttons>
                            </div>
                            <div v-if="length > 3" class="has-text-centered buttons-slider">
                                <button class="button button-left" @click="move(-1)">
                                    <b-icon
                                        icon="chevron-left"
                                        size="is-medium">
                                    </b-icon>
                                </button>
                                <button class="button button-right"  @click="move(1)">
                                    <b-icon
                                        icon="chevron-right"
                                        size="is-medium">
                                    </b-icon>
                                </button>
                            </div>
                        </div>
                        <div @click="highlightModal('center')" class="cell cell-buttons-actions is-hidden-tablet">
                            <buttons :ISIN="i.ISIN"  :fund-id="i.fund_id" :fund_data="i"></buttons>
                        </div>
                        <div class="cell">
                            <!-- <a @click="soonModalActive1=true" class="download has-text-centered">Factsheet <img src="/img/download.svg"></a> -->
                        </div>
                        <div class="cell legal-structure">
                            <p v-if="i.LegalStructureLegalName" class="has-text-centered">{{i.LegalStructureLegalName}}</p>
                            <span v-else style="color: #999">n/a</span>
                        </div>

                        <div class="cell">
                            <p v-if="i.morningstarcategories" class="has-text-centered">{{i.morningstarcategories}}</p>
                            <span v-else style="color: #999">n/a</span>
                        </div>

                        <div class="cell cell-centered">
                            <p class="has-text-centered">{{ i.LegalStructure }}</p>
                        </div>

                        <div class="cell cell-centered">
                            <p class="has-text-centered">

                                <span v-if="i.IndexFund" class="label" style="background-color: #AFEF97; color: #363636;">Passive</span>
                                <span class="label active" v-else
                                >Active</span>

                            </p>
                        </div>

                        <div class="cell investment">
                            <div class="investment-text">
                                <p class="has-text-centered">{{i.InvestmentStrategy}}</p>
                            </div>
                        </div>

                        <div class="cell cell-centered">
                            <p class="has-text-centered">{{bmark(i.benchmark)}}</p>
                        </div>

                        <div class="cell cell-centered">
                            <p class="has-text-centered">
                                <span v-if="i.isa_all || i.isa_platforms"><img class="no-yes" src="/img/tick.svg"></span>
                                <span v-else><img class="no-yes" src="/img/cross.svg"></span>
                            </p>
                        </div>

                        <div class="cell cell-centered">
                            <p class="has-text-centered">
                                <span v-if="i.sipp_all || i.sipp_platforms"><img class="no-yes" src="/img/tick.svg"></span>
                                <span v-else><img class="no-yes" src="/img/cross.svg"></span>
                            </p>
                        </div>

                        <div class="cell cell-centered">
                            <p class="has-text-centered">
                                <span v-if="i.is_esg"><img class="no-yes" src="/img/tick.svg"></span>
                                <span v-else><img class="no-yes" src="/img/cross.svg"></span>
                            </p>
                        </div>
                        
                        <div class="cell cell-centered">
                            <p class="has-text-centered">{{i.Domicile}}</p>
                        </div>

                        <div class="cell cell-centered">
                            <p class="has-text-centered" v-html="format_date(i.InceptionDate)"></p>
                        </div>

                        <div class="cell cell-centered">
                            <p class="has-text-centered" >
                                {{formatDateToYear(i.InceptionDate)}}
                            </p>
                        </div>


                        <div class="cell cell-centered">
                            <p class="has-text-centered">
                                <span v-if="i.IndexFund === false">N/A</span>
                                <span v-else-if="i.PhysicalFull || i.PhysicalSample">Yes</span>
                                <span v-else>No</span>
                            </p>
                        </div>

                        <div class="cell cell-centered">
                            <p class="has-text-centered">{{ i.CompanyBasicsName }}</p>
                        </div>

                        <div class="cell investment cell-centered">
                            <div class="investment-text" v-if="JSON.parse(i.fundmanagers).length > 0">
                                <p v-for="m in JSON.parse(i.fundmanagers)" :key="m.manager_id">
                                    {{m.GivenName}} {{m.FamilyName}} <br> {{format_date(m.StartDate)}}
                                </p>
                            </div>
                            <div class="has-text-centered" v-else>
                                <span style="color: #999">n/a</span>
                            </div>
                        </div>

                        <!--                        <div class="cell cell-centered">
                                                    <p class="has-text-centered">
                                                    <span v-for="m in JSON.parse(i.fundmanagers)" :key="m.manager_id">
                                                        <div>{{format_date(m.StartDate)}}</div>
                                                    </span>
                                                    </p>
                                                </div>
                                                <div class="cell cell-centered">
                                                    <p class="has-text-centered">
                                                    <span v-for="m in this.managers" :key="m.manager_id">
                                                        <span>{{timeSince(m.StartDate)}}</span>
                                                    </span>
                                                    </p>
                                                </div>-->


                        <div class="cell cell-centered">
                            <p v-if="i.oldest_manager_date_ago" class="has-text-centered">
                                {{i.oldest_manager_date_ago}} {{i.oldest_manager_date_ago > 1 ? 'years' : 'year'}}
                            </p>
                            <span v-else style="color: #999">n/a</span>
                        </div>

                        <div class="cell cell-centered">
                            <p v-if="i.CountryFocusId" class="has-text-centered">
                                {{i.CountryFocusId}}
                            </p>
                            <span v-else style="color: #999">n/a</span>
                        </div>
                        <div class="cell cell-centered">
                            <p v-if="i.SectorFocusId" class="has-text-centered">
                                {{i.SectorFocusId}}
                            </p>
                            <span v-else style="color: #999">n/a</span>
                        </div>
                        <div class="cell cell-centered">
                            <p v-if="i.ima_name" class="has-text-centered">
                                {{i.ima_name}}
                            </p>
                            <span v-else style="color: #999">n/a</span>
                        </div>
                        <div class="cell cell-centered">
                            <p v-if="i.ticker" class="has-text-centered">
                                {{i.ticker}}
                            </p>
                            <span v-else style="color: #999">n/a</span>
                        </div>

                        <div class="cell cell-empty">

                        </div>

                        <div class="cell cell-centered cell-text-long">
                            <p class="has-text-centered">
                                {{i.ShareClassBasicsName}}
                            </p>
                        </div>


                        <div class="cell cell-centered">
                            <p class="has-text-centered">

                                {{i.ISIN}}

                            </p>
                        </div>


                        <div class="cell cell-centered is-size-7-mobile">
                            <pos-neg :val="i.CumulativeTotalReturnTD" :round="2" :suffix="'%'"/>
                        </div>

                        <div class="cell cell-centered is-size-7-mobile">

                            <pos-neg :val="i.CumulativeTotalReturn1Year" :round="2" :suffix="'%'"/>

                        </div>



                        <div class="cell cell-centered is-size-7-mobile">

                            <pos-neg :val="i.TotalReturn3Years" :round="2" :suffix="'%'"/>


                        </div>


                        <div class="cell cell-centered is-size-7-mobile">

                            <pos-neg :val="i.TotalReturn5Years" :round="2" :suffix="'%'"/>

                        </div>

                        <div class="cell cell-centered is-size-7-mobile">

                            <pos-neg :val="i.standarddev36m" :round="2" :suffix="'%'"/>

                        </div>

                        <div class="cell cell-centered is-size-7-mobile">

                            <pos-neg :val="i.maxdrawdown3Y" :round="2" :suffix="'%'"/>

                        </div>

                        <div class="cell cell-centered is-size-7-mobile">

                            <pos-neg :val="i.sharperatio3Y" :round="2" :suffix="''"/>

                        </div>


                        <div class="cell cell-centered is-size-7-mobile">
                            <pos-neg v-if="isSpreadBenchmarkSelected" :val="i.CumulativeTotalReturnTD - (isSpreadBenchmarkSelected.benchmarkTD ? isSpreadBenchmarkSelected.benchmarkTD : i.spreadvsbenchmarkytd)" :round="2" :suffix="'%'" :bg-color="benchmarkHighlightColor"/>
                            <div v-else class="has-text-weight-bold">Select Benchmark</div>
                        </div>

                        <div class="cell cell-centered is-size-7-mobile">
                            <pos-neg v-if="isSpreadBenchmarkSelected" :val="i.CumulativeTotalReturn1Year - (isSpreadBenchmarkSelected.benchmark1Y ? isSpreadBenchmarkSelected.benchmark1Y : i.spreadvsbenchmark1y)" :round="2" :suffix="'%'" :bg-color="benchmarkHighlightColor"/>
                            <div v-else class="has-text-weight-bold">Select Benchmark</div>
                        </div>

                        <div class="cell cell-centered is-size-7-mobile">
                            <pos-neg v-if="isSpreadBenchmarkSelected" :val="i.TotalReturn3Years - (isSpreadBenchmarkSelected.benchmark3Y ? isSpreadBenchmarkSelected.benchmark3Y : i.spreadvsbenchmark3y)" :round="2" :suffix="'%'" :bg-color="benchmarkHighlightColor"/>
                            <div v-else class="has-text-weight-bold">Select Benchmark</div>
                        </div>

                        <div class="cell cell-centered is-size-7-mobile">
                            <pos-neg v-if="isSpreadBenchmarkSelected" :val="i.TotalReturn5Years - (isSpreadBenchmarkSelected.benchmark5Y ? isSpreadBenchmarkSelected.benchmark5Y : i.spreadvsbenchmark5y)" :round="2" :suffix="'%'" :bg-color="benchmarkHighlightColor"/>
                            <div v-else class="has-text-weight-bold">Select Benchmark</div>
                        </div>

                        <div class="cell cell-empty">

                        </div>


                        <div class="cell cell-centered is-size-7-mobile">
                            <pos-neg :val="i.ongoingchargecomp" :round="2" :suffix="'%'"/>
                        </div>

                        <div class="cell cell-centered is-size-7-mobile">
                            <pos-neg :val="i.ManagementFeeValue" :round="2" :suffix="'%'"/>
                        </div>

                        <div class="cell cell-centered is-size-7-mobile">
                            <p v-bind:class = "(i.PerformanceFeeValue < 0)?'red has-text-centered':'has-text-centered'">
                                 <span v-if="i.PerformanceFeeValue">
                                                             <pos-neg :val="i.performancefee_oldest_share" :round="2" :suffix="'%'"/>

                                 </span>
                                <span v-else>N/A</span>
                            </p>
                        </div>


                        <div class="cell cell-empty">

                        </div>

                        <div class="cell cell-centered is-size-7-mobile">

                            <pos-neg :val="i.yield12m" :round="2" :suffix="'%'"/>

                        </div>

                        <div class="cell cell-centered">
                            <p class="has-text-centered" v-html="accinc(i, $store.state.search.lastSearch)">
<!--                                <span v-if="i.IncomeDistribution && i.AccumulatedDistribution">INCOME & ACCUMULATION</span>
                                <span v-else-if="i.IncomeDistribution">INCOME</span>
                                <span v-else-if="i.AccumulatedDistribution">ACCUMULATION</span>
                                <span v-else>-</span>-->

                            </p>
                        </div>

                        <div class="cell cell-centered">
                            <p v-if="JSON.parse(i.distributionfrequency_all).length > 0" class="has-text-centered">
                            <span v-for="(f, index) in JSON.parse(i.distributionfrequency_all)" :key="index">
                                {{getFreq(f)}}
                            </span>
                            </p>
                            <p v-else style="color: #999">n/a</p>
                        </div>


                        <div class="cell cell-empty">

                        </div>

                        <div class="cell cell-centered">
                            <p class="has-text-centered">
                               {{i.CurrencyId}}
                            </p>
                        </div>


                        <div class="cell cell-centered">
                            <p class="has-text-centered">

                                <span v-if="i.othercurrencies_all === true">Yes</span>
                                <span v-else>No</span>

                            </p>
                        </div>


                        <div class="cell cell-centered">
                            <p class="has-text-centered">

                                <span v-if="i.currencyhedged_all">Yes</span>
                                <span v-else>No</span>

                            </p>
                        </div>

                        <div class="cell cell-centered">

                            <pos-neg :val="i.NAV" :round="2" />

                        </div>

                        <div class="cell cell-centered">
                            <p class="has-text-centered" v-html="format_date(i.Lastupdated)">

                            </p>
                        </div>

                        <!-- <div class="cell cell-centered">
                            <pos-neg :val="i.ClosePrice" :round="2" />
                        </div>

                        <div class="cell cell-centered">
                            <p class="has-text-centered" v-html="format_date(i.Navdate)"></p>
                        </div> -->

                        <div class="cell cell-centered">
                            <pos-neg :val="i.discounttoNAV" :round="2" :suffix="'%'"/>
                        </div>

                        <div class="cell cell-centered">
                            <pos-neg :val="i.ChangeInPrice" :round="2" :suffix="'%'"/>
                        </div>

                        <div class="cell cell-centered">
                            <p class="has-text-centered">

                            </p>
                        </div>




                        <div v-bind:class = "(i.riskrating_6M < 0)?'red cell cell-empty has-text-centered':'cell cell-empty has-text-centered'">
                              <pos-neg :val="i.riskrating_6M" :round="0"  />
                        </div>

                        <div class="cell cell-centered">
                            <p class="has-text-centered">

                            <span class="is-white-space-nowrap" v-if="i.starrating36M && !isNaN(i.starrating36M)">

                                <span v-for="(r, index) in parseInt(i.starrating36M)" :key="index"><img class="star" src="/img/star-2.svg"/></span>



                            </span>
                                <span v-else style="color: #999">n/a</span>

                            </p>
                        </div>


                        <div class="cell cell-empty">

                        </div>

                        <div class="cell cell-centered">
                            <p v-bind:class = "(i.fundnetassetgbp < 0)?'red has-text-centered':'has-text-centered'" >
                                <span>{{currency("GBP", parseNA(i.fundnetassetgbp)) }}m</span>
                            </p>
                        </div>


                        <div class="cell cell-centered">
                            <p v-bind:class = "(i.NumberOfHolding < 0)?'red has-text-centered':'has-text-centered'" >
                                <pos-neg :val="i.NumberOfHolding" :round="0"/>
                            </p>
                        </div>


                    </div>
                    <div v-if="x" class="col" :class="highlightRight ? 'z-index-52' : ''">
                        <div class="cell cell-header header-tablet">
                            <h3 class="has-text-centered text-overflow pl-3">{{getShort(x.FundBasicsName)}}</h3>
                            <div class="buttons-actions is-hidden-mobile" @click="highlightModal('right')">
                                <buttons :ISIN="x.ISIN" :fund-id="x.fund_id" :fund_data="x"></buttons>
                            </div>
                        </div>
                        <div @click="highlightModal('right')" class="cell cell-buttons-actions is-hidden-tablet">
                            <buttons :ISIN="x.ISIN" :fund-id="x.fund_id" :fund_data="x"></buttons>
                        </div>
                        <div class="cell">
                            <!-- <a @click="soonModalActive1=true" class="download has-text-centered">Factsheet <img src="/img/download.svg"></a> -->
                        </div>

                        <div class="cell legal-structure">
                            <p v-if="x.LegalStructureLegalName" class="has-text-centered">{{x.LegalStructureLegalName}}</p>
                            <span v-else style="color: #999">n/a</span>
                        </div>
                        <div class="cell">
                            <p v-if="x.morningstarcategories" class="has-text-centered">{{x.morningstarcategories}}</p>
                            <span v-else style="color: #999">n/a</span>
                        </div>

                        <div class="cell cell-centered">
                            <p class="has-text-centered">{{ x.LegalStructure }}</p>
                        </div>

                        <div class="cell cell-centered">
                            <p class="has-text-centered">

                                <span v-if="x.IndexFund" class="label" style="background-color: #AFEF97; color: #363636;">Passive</span>
                                <span class="label active" v-else
                                >Active</span>

                            </p>
                        </div>

                        <div class="cell investment">
                            <div class="investment-text">
                                <p class="has-text-centered">{{x.InvestmentStrategy}}</p>
                            </div>
                        </div>

                        <div class="cell cell-centered">
                            <p class="has-text-centered">{{bmark(x.benchmark)}}</p>
                        </div>

                        <div class="cell cell-centered">
                            <p class="has-text-centered">
                                <span v-if="x.isa_all || x.isa_platforms"><img class="no-yes" src="/img/tick.svg"></span>
                                <span v-else><img class="no-yes" src="/img/cross.svg"></span>
                            </p>
                        </div>

                        <div class="cell cell-centered">
                            <p class="has-text-centered">
                                <span v-if="x.sipp_all || x.sipp_platforms"><img class="no-yes" src="/img/tick.svg"></span>
                                <span v-else><img class="no-yes" src="/img/cross.svg"></span>
                            </p>
                        </div>

                        <div class="cell cell-centered">
                            <p class="has-text-centered">
                                <span v-if="x.is_esg"><img class="no-yes" src="/img/tick.svg"></span>
                                <span v-else><img class="no-yes" src="/img/cross.svg"></span>
                            </p>
                        </div>
                        
                        <div class="cell cell-centered">
                            <p class="has-text-centered">{{x.Domicile}}</p>
                        </div>

                        <div class="cell cell-centered">
                            <p class="has-text-centered" v-html="format_date(x.InceptionDate)">{{}}</p>
                        </div>

                        <div class="cell cell-centered">
                            <p class="has-text-centered">
                                {{formatDateToYear(x.InceptionDate)}}
                            </p>
                        </div>


                        <div class="cell cell-centered">
                            <p class="has-text-centered">
                                <span v-if="x.IndexFund === false">N/A</span>
                                <span v-else-if="x.PhysicalFull || x.PhysicalSample">Yes</span>
                                <span v-else>No</span>
                            </p>
                        </div>

                        <div class="cell cell-centered">
                            <p class="has-text-centered">{{ x.CompanyBasicsName }}</p>
                        </div>

                        <div class="cell investment cell-centered">
                            <div class="investment-text" v-if="JSON.parse(x.fundmanagers).length > 0">
                                <p v-for="m in JSON.parse(x.fundmanagers)" :key="m.manager_id">
                                    {{m.GivenName}} {{m.FamilyName}} <br> {{format_date(m.StartDate)}}
                                </p>
                            </div>
                            <div class="has-text-centered" v-else>
                                <span style="color: #999">n/a</span>
                            </div>
                        </div>

                        <!--                        <div class="cell cell-centered">
                                                    <p class="has-text-centered">
                                                    <span v-for="m in JSON.parse(x.fundmanagers)" :key="m.manager_id">
                                                        <div>{{format_date(m.StartDate)}}</div>
                                                    </span>
                                                    </p>
                                                </div>
                                                <div class="cell cell-centered">
                                                    <p class="has-text-centered">
                                                    <span v-for="m in this.managers" :key="m.manager_id">
                                                        <span>{{timeSince(m.StartDate)}}</span>
                                                    </span>
                                                    </p>
                                                </div>-->


                        <div class="cell cell-centered">
                            <p v-if="x.oldest_manager_date_ago" class="has-text-centered">
                                {{x.oldest_manager_date_ago}} {{x.oldest_manager_date_ago > 1 ? 'years' : 'year'}}
                            </p>
                            <span v-else style="color: #999">n/a</span>
                        </div>

                        <div class="cell cell-centered">
                            <p v-if="x.CountryFocusId" class="has-text-centered">
                                {{x.CountryFocusId}}
                            </p>
                            <span v-else style="color: #999">n/a</span>
                        </div>
                        <div class="cell cell-centered">
                            <p v-if="x.SectorFocusId" class="has-text-centered">
                                {{x.SectorFocusId}}
                            </p>
                            <span v-else style="color: #999">n/a</span>
                        </div>
                        <div class="cell cell-centered">
                            <p v-if="x.ima_name" class="has-text-centered">
                                {{x.ima_name}}
                            </p>
                            <span v-else style="color: #999">n/a</span>
                        </div>
                        <div class="cell cell-centered">
                            <p v-if="x.ticker" class="has-text-centered">
                                {{x.ticker}}
                            </p>
                            <span v-else style="color: #999">n/a</span>
                        </div>
                        <div class="cell cell-empty">

                        </div>

                        <div class="cell cell-centered cell-text-long">
                            <p class="has-text-centered">

                                {{x.ShareClassBasicsName}}

                            </p>
                        </div>


                        <div class="cell cell-centered">
                            <p class="has-text-centered">

                                {{x.ISIN}}

                            </p>
                        </div>


                        <div class="cell cell-centered is-size-7-mobile">

                            <pos-neg :val="x.CumulativeTotalReturnTD" :round="2" :suffix="'%'"/>

                        </div>

                        <div class="cell cell-centered is-size-7-mobile">

                            <pos-neg :val="x.CumulativeTotalReturn1Year" :round="2" :suffix="'%'"/>

                        </div>



                        <div class="cell cell-centered is-size-7-mobile">

                            <pos-neg :val="x.TotalReturn3Years" :round="2" :suffix="'%'"/>

                        </div>


                        <div class="cell cell-centered is-size-7-mobile">
                            <pos-neg :val="x.TotalReturn5Years" :round="2" :suffix="'%'"/>
                        </div>

                        <div class="cell cell-centered is-size-7-mobile">

                            <pos-neg :val="x.standarddev36m" :round="2" :suffix="'%'"/>

                        </div>

                        <div class="cell cell-centered is-size-7-mobile">

                            <pos-neg :val="x.maxdrawdown3Y" :round="2" :suffix="'%'"/>

                        </div>

                        <div class="cell cell-centered is-size-7-mobile">

                            <pos-neg :val="x.sharperatio3Y" :round="2" :suffix="''"/>

                        </div>


                        <div class="cell cell-centered is-size-7-mobile">
                            <pos-neg v-if="isSpreadBenchmarkSelected" :val="x.CumulativeTotalReturnTD - (isSpreadBenchmarkSelected.benchmarkTD ? isSpreadBenchmarkSelected.benchmarkTD : x.spreadvsbenchmarkytd)" :round="2" :suffix="'%'" :bg-color="benchmarkHighlightColor"/>
                            <div v-else class="has-text-weight-bold">Select Benchmark</div>
                        </div>

                        <div class="cell cell-centered is-size-7-mobile">
                            <pos-neg v-if="isSpreadBenchmarkSelected" :val="x.CumulativeTotalReturn1Year - (isSpreadBenchmarkSelected.benchmark1Y ? isSpreadBenchmarkSelected.benchmark1Y : x.spreadvsbenchmark1y)" :round="2" :suffix="'%'" :bg-color="benchmarkHighlightColor"/>
                            <div v-else class="has-text-weight-bold">Select Benchmark</div>
                        </div>

                        <div class="cell cell-centered is-size-7-mobile">
                            <pos-neg v-if="isSpreadBenchmarkSelected" :val="x.TotalReturn3Years - (isSpreadBenchmarkSelected.benchmark3Y ? isSpreadBenchmarkSelected.benchmark3Y : x.spreadvsbenchmark3y)" :round="2" :suffix="'%'" :bg-color="benchmarkHighlightColor"/>
                            <div v-else class="has-text-weight-bold">Select Benchmark</div>
                        </div>

                        <div class="cell cell-centered is-size-7-mobile">
                            <pos-neg v-if="isSpreadBenchmarkSelected" :val="x.TotalReturn5Years - (isSpreadBenchmarkSelected.benchmark5Y ? isSpreadBenchmarkSelected.benchmark5Y : x.spreadvsbenchmark5y)" :round="2" :suffix="'%'" :bg-color="benchmarkHighlightColor"/>
                            <div v-else class="has-text-weight-bold">Select Benchmark</div>
                        </div>

                        <div class="cell cell-empty">

                        </div>


                        <div class="cell cell-centered is-size-7-mobile">
                            <pos-neg :val="x.ongoingchargecomp" :round="2" :suffix="'%'"/>
                        </div>

                        <div class="cell cell-centered is-size-7-mobile">

                            <pos-neg :val="x.ManagementFeeValue" :round="2" :suffix="'%'"/>

                        </div>

                        <div class="cell cell-centered is-size-7-mobile">
                            <p v-bind:class = "(x.PerformanceFeeValue < 0)?'red has-text-centered':'has-text-centered'">
                                 <span v-if="x.PerformanceFeeValue">
                                     <pos-neg :val="x.performancefee_oldest_share" :round="2" :suffix="'%'"/>
                                 </span>
                                <span v-else>N/A</span>
                            </p>

                        </div>


                        <div class="cell cell-empty">

                        </div>

                        <div class="cell cell-centered is-size-7-mobile">

                            <pos-neg :val="x.yield12m" :round="2" :suffix="'%'"/>

                        </div>

                        <div class="cell cell-centered">
                            <p class="has-text-centered" v-html="accinc(x, $store.state.search.lastSearch)">
<!--                                <span v-if="x.IncomeDistribution && x.AccumulatedDistribution">INCOME & ACCUMULATION</span>
                                <span v-else-if="x.IncomeDistribution">INCOME</span>
                                <span v-else-if="x.AccumulatedDistribution">ACCUMULATION</span>
                                <span v-else>-</span>-->

                            </p>
                        </div>

                        <div class="cell cell-centered">
                            <p v-if="JSON.parse(x.distributionfrequency_all).length > 0" class="has-text-centered">
                            <span v-for="(f, index) in JSON.parse(x.distributionfrequency_all)" :key="index">
                                {{getFreq(f)}}
                            </span>
                            </p>
                            <p v-else style="color: #999">n/a</p>
                        </div>


                        <div class="cell cell-empty">

                        </div>

                        <div class="cell cell-centered">
                            <p class="has-text-centered">

                               {{x.CurrencyId}}

                            </p>
                        </div>


                        <div class="cell cell-centered">
                            <p class="has-text-centered">

                                <span v-if="x.othercurrencies_all === true">Yes</span>
                                <span v-else>No</span>

                            </p>
                        </div>


                        <div class="cell cell-centered">
                            <p class="has-text-centered">

                                <span v-if="x.currencyhedged_all">Yes</span>
                                <span v-else>No</span>

                            </p>
                        </div>

                        <div class="cell cell-centered">
                            <p v-bind:class = "(x.NAV < 0)?'red has-text-centered':'has-text-centered'">

                                <pos-neg :val="x.NAV" :round="2" :suffix="''"/>


                            </p>
                        </div>

                        <div class="cell cell-centered">
                            <p class="has-text-centered" v-html="format_date(x.Lastupdated)">

                                {{}}

                            </p>
                        </div>

                        <!-- <div class="cell cell-centered">
                            <pos-neg :val="x.ClosePrice" :round="2" />
                        </div>

                        <div class="cell cell-centered">
                            <p class="has-text-centered" v-html="format_date(x.Navdate)"></p>
                        </div> -->


                        <div class="cell cell-centered">
                            <p class="has-text-centered">
                                <pos-neg :val="x.discounttoNAV" :round="2" :suffix="'%'"/>
                            </p>
                        </div>

                        <div class="cell cell-centered">
                            <p class="has-text-centered">
                                <pos-neg :val="x.ChangeInPrice" :round="2" :suffix="'%'"/>
                            </p>
                        </div>

                        <div class="cell cell-centered">
                            <p class="has-text-centered">

                            </p>
                        </div>




                        <div v-bind:class = "(x.riskrating_6M < 0)?'red cell cell-empty has-text-centered':'cell cell-empty has-text-centered'">
                            <pos-neg :val="x.riskrating_6M" :round="0"  />
                        </div>

                        <div class="cell cell-centered">
                            <p class="has-text-centered">

                            <span class="is-white-space-nowrap" v-if="x.starrating36M && !isNaN(x.starrating36M)">

                                <span v-for="(r, index) in parseInt(x.starrating36M)" :key="index"><img class="star" src="/img/star-2.svg"/></span>

                            </span>
                                <span v-else style="color: #999">n/a</span>


                            </p>
                        </div>


                        <div class="cell cell-empty">

                        </div>

                        <div class="cell cell-centered">
                            <p v-bind:class = "(x.fundnetassetgbp < 0)?'red has-text-centered':'has-text-centered'" >
                                <span>{{currency("GBP", parseNA(x.fundnetassetgbp)) }}m</span>
                            </p>
                        </div>


                        <div class="cell cell-centered">
                            <p v-bind:class = "(x.NumberOfHolding < 0)?'red has-text-centered':'has-text-centered'" >
                                <pos-neg :val="x.NumberOfHolding" :round="0" />
                            </p>
                        </div>

                    </div>
                </div>
                <div class="columns is-mobile">
                    <div class="column disclaimer">
                        <Disclaimer />
                    </div>
                </div>
            </div>
            <div ref="subRight_before" class="column is-12-mobile is-3-desktop">
                <div class="banner-on-top" ref="subRight">
                    <AdsPartner />
                </div>
            </div>
        </div>
        <b-modal
            v-model="soonModalActive1"
            has-modal-card
            trap-focus
            :destroy-on-hide="false"
            aria-role="dialog"
            aria-label="Example Modal"
            aria-modal>
            <template >
                <div class="modal-card" style="width: auto">
                    <section  class="modal-card-body py-5 px-6">
                        <button
                            type="button"
                            class="delete"
                            @click="soonModalActive1=false"/>
                        <h3 class="has-text-centered dark-text">Coming soon!</h3>
                    </section>
                </div>
            </template>
        </b-modal>


       <!-- <pre>{{i}}</pre> -->
    </div>




</template>

<style scoped>
    .about-video {
        @media (min-width: 768px) {
            margin-top: -144px;
        }
    }
</style>
<script>
// import {getCat, getLegal, currency, getShort, getFreq} from "../plugins/cats"
import axios from "axios"
import commonMixin from "@/mixins/commonMixin";
import compositeMixin from "@/mixins/compositeMixin";
import bannerMixin from "@/mixins/bannerMixin";

import moment from 'moment'
import Buttons from "@/components/Buttons";
import PosNeg from "@/components/PosNeg";
import CurrencyToggle from '../components/CurrencyToggle.vue';
import PageHelp from '@/components/PageHelp.vue';
import Disclaimer from "@/components/Disclaimer"
import AdsPartner from '@/components/AdsPartner.vue';

export default {
    name: 'Detailedview',
    components:{PosNeg, Buttons, CurrencyToggle, PageHelp, Disclaimer, AdsPartner },
    mixins:
        [commonMixin, compositeMixin, bannerMixin],
    props: {
        //detailed: Object,
        currencyNative: Boolean
    },
    data(){
        return{
            initialKey:0,
            copy:[],
            pageData:[],
            i: null,
            a: null,
            x: this.detailed,
            key:null,
            length:0,
            lastDirection:0,
            soonModalActive1: false,
            title: '',
            highlightLeft: false,
            highlightCenter: false,
            highlightRight: false,
            colHighlight: 'highlightCenter',
            benchmarkHighlightColor: '#FFFE00'
        }
    },
    computed: {
        handleTitle() {
            return this.$router.currentRoute.name;
        },
        isSpreadBenchmarkSelected() {
            return this.$store.state.search.compareBenchmarkFilter
        }
    },
    watch: {
        '$store.state.messages.modalAlert'() {
            this.checkCloseModal()
        },
        '$store.state.messages.modalWatchlistAddFund'() {
            this.checkCloseModal()
        },
        '$store.state.messages.modalWatchlistCreateNew'() {
            this.checkCloseModal()
        }
    },
    methods:{
        checkCloseModal() {
            if(!this.$store.state.messages.modalAlert && !this.$store.state.messages.modalWatchlistAddFund
                && !this.$store.state.messages.modalWatchlistCreateNew) {
                this.highlightLeft = false;
                this.highlightCenter = false;
                this.highlightRight = false;
            } else {
                this[this.colHighlight] = true;
            }
        },
        highlightModal(type) {
            switch (type) {
                case 'left':
                    this.highlightLeft = true;
                    this.highlightCenter = false;
                    this.highlightRight = false;
                    this.colHighlight = 'highlightLeft';
                    break;
                case 'center':
                    this.highlightLeft = false;
                    this.highlightCenter = true;
                    this.highlightRight = false;
                    this.colHighlight = 'highlightCenter';
                    break;
                case 'right':
                    this.highlightLeft = false;
                    this.highlightCenter = false;
                    this.highlightRight = true;
                    this.colHighlight = 'highlightRight';
                    break;

                default:
                    break;
            }
            this.checkCloseModal()
        },
        formatDateToYear(date) {
            if(this.getDayOfYear(date) > 1) return `${this.getDayOfYear(date)} years`
            else return `${this.getDayOfYear(date)} year`
        },
        format_date(value){
            if (value) {
                return moment(String(value)).format('DD-MMM-YY')
            }
            else{
                return "<span style='#ccc'>n/a</span>"
            }
        },
        bmark(bm){
            if(bm){
                const b = bm.toLowerCase()
                if(b == "not benchmarked" ||b == "no benchmark" ||b == "n/a"){
                    return "Unconstrained"
                }
                else{
                    return bm
                }
            }
            return "Unconstrained"
        },
        move(n){
            if(this.key >= this.pageData.length){
                this.key = this.key - 1
            }
            if(n<0){
                this.pageData.unshift(this.pageData.pop())
                this.a = this.pageData[this.key-1]
                this.x = this.pageData[this.key]
            }
            else{
                this.pageData.push(this.pageData.shift())
                this.a = this.pageData[this.key-1]
                this.x = this.pageData[this.key]
            }
        },
        parseData(id){
            let key = null
            key = this.pageData.findIndex(obj => {
                if(obj.hasOwnProperty(id) && obj[id] != null){
                    return obj[id] == this.$route.params.id
                }
                else{
                    alert("Nooo")
                    return obj.FundShareClassId === this.$route.params.id
                }
            })
            if(key==0){
                this.pageData.unshift(this.pageData.pop())
                key=1
            }
            this.key = key
            this.length = this.pageData.length
        }
    },

    async created() {
        let key = null
        if(this.$route.name == "Detailedview Top Funds List"){
            this.pageData = this.$store.state.topFundList.list;
            this.parseData("ISIN")
        } else if(this.$route.name == "Detailedview Shortlist"){
            this.pageData = JSON.parse(JSON.stringify(this.$store.state.shortlist.fullshortlist))
            this.parseData("ISIN")
        }
        else if(this.$route.name == "Detailedview Comparison"){
            await this.$store.dispatch("compare/getComparison",this.$store.state.search.currency,null)
            this.pageData = JSON.parse(JSON.stringify(this.$store.state.compare.top15))
            this.parseData("ISIN")
        }
        else if (this.$route.params.type == 'viewed') {
            this.pageData = this.$store.state.fund.fundsRecentlyViewed
            this.parseData("ISIN")
        }
        else if (this.$route.params.type == 'compared') {
            this.pageData = this.$store.state.fund.fundsRecentlyCompared
            this.parseData("ISIN")
        }
        else if (this.$route.params.type == 'referrals') {
            this.pageData = this.$store.state.fund.fundsRecentlyReferrals
            this.parseData("ISIN")
        }
        else if(typeof this.$store.state.search.searchData.data == 'object'){
            key = this.$store.state.search.searchData.data.findIndex(obj => {
                return obj.ISIN === this.$route.params.id || obj.FundShareClassId === this.$route.params.id
            })
            this.key = key
            if(this.key >= 0 && this.$route.query.source === 'search') {
                this.length = this.$store.state.search.searchData.data.length;
                Object.assign(this.pageData, this.$store.state.search.searchData.data);
            } else {
                await axios
                .get("/search/representative-page", {
                params: {
                    ISIN: this.$route.params.id,
                    ...this.$route.query,
                },
                })
                .then((response) => {
                this.pageData = response.data.data;
                this.parseData("ISIN");
                });
            }
        }
        else if(this.$store.state.compare.typeCompareDetail === 'watchlist_page') {
            key = this.$store.state.watchlist.searchData.items.findIndex(obj => {
                return obj.ISIN === this.$route.params.id || obj.FundShareClassId === this.$route.params.id
            })
            this.key = key
            this.length = this.$store.state.watchlist.searchData.items.length
            Object.assign(this.pageData, this.$store.state.watchlist.searchData.items)
        }
        else {
            await axios
                .get("/search/representative-page", {
                params: {
                    ISIN: this.$route.params.id,
                    ...this.$route.query,
                },
            }).then(response => {
                    this.pageData = response.data.data
                    this.parseData("ISIN")
                })
        }
        if(this.key==0){
            this.pageData.unshift(this.pageData.pop())
            this.key=1
            this.a = this.pageData[0]
            this.i = this.pageData[this.key]
            this.x = this.pageData[this.key+1]
        }
        else if(this.key+1 == this.pageData.length){
            this.key = this.key-1
            this.pageData.push(this.pageData.shift())
            this.a = this.pageData[this.key-1]
            this.i = this.pageData[this.key ]
            this.x = this.pageData[this.key+1]
        }
        else{
            this.a = this.pageData.length > 1 ? this.pageData[this.key-1] : null
            this.i = this.pageData.length > 1 ? this.pageData[this.key] : this.pageData[0]
            this.x = this.pageData.length > 1 ? this.pageData[this.key+1] : null
        }
        if (this.i && this.i.id) {
             const id = this.pageData.findIndex(obj => obj.id == this.i.id)
             this.pageData.splice(id, 1);
             axios.get("/search/savedetviewdata", {
                params: {
                    ISIN: this.i.ISIN,
                    source: this.$store.state.compare.typeCompareDetail,
                    toggle: this.$store.state.search.currency
                }
            })
        }
        this.$store.commit('compare/SET_TYPE_COMPARE_DETAIL', 'detailed_page');

        window.addEventListener('scroll', this.handleScroll);
    },
    metaInfo() {
        return {
            title: `${this.i ? this.getShort(this.i.FundBasicsName) + ' - ' : ''}Detailed View | Pickafund`,
            meta: [
                { vmid: 'og:description', property: 'og:description', name: 'description', content:  "Check out the list of attributes for your Fund (more than 40 parameters available)"},
                { vmid: 'og:title', property: 'og:title', content: `${this.i ? this.getShort(this.i.FundBasicsName) : ''} - Detailed View | Pickafund`},
            ],
            content: "Pickafund searches thousands of Funds available to UK retail invertors - giving you a complete, unbiased view of what's on offer. Check out this Fund!"
        }
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll);
    },
}

</script>



<style>
.red{
    color: red;
}

</style>
